import { ui } from ".";
import { Logger } from "./logger";

/**以下のインポートは開発時のみ使用 */
//import { Adjust } from "../_adjustJS/adjust.js";
//import { AdjustConfig } from "../_adjustJS/adjust_config.js";
//import { AdjustEvent } from "../_adjustJS/adjust_event.js";
//import { AdjustThirdParty } from "../_adjustJS/adjust_third_party_sharing.js";

// WebView
interface Window {
    WebViewJavascriptBridge?: any;
    WVJBCallbacks?: any;
    location: any;
}
declare const window: Window;

/** 以下の内容はリリース時は有効 */
declare const Adjust: any;
declare const AdjustConfig: any;
declare const AdjustEvent: any;
declare const AdjustThirdParty: any;

export class AdjustRecord {
    // 変数定義
    private _token: string;
    private _eventID: string;
    private _logic: adjustLogicBase = null;

    constructor(token: string, eventID: string) {
        this._token = token;
        this._eventID = eventID;

        // 対象かどうかを確認
        if (!this.isTarget()) return;

        // 各ロジックの選択と初期化
        this._logic = this.logicFactory();

        this.logicExec();
    }

    private isTarget(): boolean {
        if (!this._token) {
            // トークンの値が入っていない場合は抜ける
            return false;
        }

        if (!this._eventID) {
            // イベントIDの値が入っていない場合は抜ける
            return false;
        }

        if (!ui.isWebView()) {
            // webviewでない場合は抜ける
            return false;
        }

        if (!ui.isEnabledAdjustApp()) {
            // 対象のアプリでない場合は抜ける
            return false;
        }

        return true;
    }

    private logicExec(): void {
        if (!this._logic) {
            return;
        }
        this._logic.exec(this._token, this._eventID);
    }

    private logicFactory(): adjustLogicBase {
        if (ui.isiOS()) {
            //　setupWebViewJavascriptBridgeの実行
            Logger.info(`Adjust iOS:${this._token}:${this._eventID}`);
            return new adjustiOSLogic();
        } else if (ui.isAndroid()) {
            // 該当のscriptタグを追加      
            Logger.info(`Adjust Android:${this._token}:${this._eventID}`);
            return new adjustAndroidLogic();
        } else {
            // iOS/Androidでない場合は抜ける
            return null;
        }
    }
}

abstract class adjustLogicBase {
    abstract exec(token: string, eventID: string): void;
    public isDebug = false;
    public readonly devUrl = ["localhost", "127.0.0.1", "stg-pcs-prt-ja"];

    constructor() {

        // URLを見てデバッグかどうかを判定する。
        const current = window.location.href;
        this.isDebug = this.devUrl.filter(url => {
            return current.indexOf(url) > 0;
        }).length > 0;
        Logger.debug(`adjustRecord.ts: debug mode [${this.isDebug}]`);
    }
}


class adjustiOSLogic extends adjustLogicBase {
    public exec(token: string, eventID: string): void {
        function setupWebViewJavascriptBridge(callback) {
            if (window.WebViewJavascriptBridge) {
                return callback(WebViewJavascriptBridge);
            }

            if (window.WVJBCallbacks) {
                return window.WVJBCallbacks.push(callback);
            }

            window.WVJBCallbacks = [callback];

            var WVJBIframe = document.createElement('iframe');
            WVJBIframe.style.display = 'none';
            WVJBIframe.src = 'https://__bridge_loaded__';
            document.documentElement.appendChild(WVJBIframe);

            setTimeout(function () { document.documentElement.removeChild(WVJBIframe) }, 0)
        }

        const that = this;
        setupWebViewJavascriptBridge(function (bridge) {
            const environment = that.isDebug ? AdjustConfig.EnvironmentSandbox : AdjustConfig.EnvironmentProduction;
            const adjustConfig = new AdjustConfig(token, environment);
            Adjust.appDidLaunch(adjustConfig);

            // イベント発火
            // グローバル変数Adjust内にtrackEventが含まれないために
            // ここでイベント処理を行う
            var adjustEvent = new AdjustEvent(eventID);
            Adjust.trackEvent(adjustEvent);
        });
    }
}
class adjustAndroidLogic extends adjustLogicBase {
    // スクリプト要素の追加
    public exec(token: string, eventID: string): void {
        // headerに要素を追加
        const addScripts = `
        <script type = "text/javascript" src = "./js/adjustJS/adjust.js"></script>
        <script type = "text/javascript" src = "./js/adjustJS/adjust_event.js"></script>
        <script type = "text/javascript" src = "./js/adjustJS/adjust_third_party_sharing.js"></script>
        <script type = "text/javascript" src = "./js/adjustJS/adjust_config.js"></script>
        `;
        $('head').append(addScripts);

        const environment = this.isDebug ? AdjustConfig.EnvironmentSandbox : AdjustConfig.EnvironmentProduction;
        const adjustConfig = new AdjustConfig(token, environment);

        Adjust.onCreate(adjustConfig);

        // イベント発火
        // iOSに合わせてAdjustの準備ができてから
        // イベント処理を登録
        var adjustEvent = new AdjustEvent(eventID);
        Adjust.trackEvent(adjustEvent);
    }

}

// SDKが読み込まれた場合は以下の内容は不要
// iOSの初期化時のエラー対応
function WebViewJavascriptBridge(WebViewJavascriptBridge: any) {
    throw new Error("Function not implemented.");
}
